import React, { lazy, Suspense } from 'react'
import { Button, Container, Row, Col } from 'react-bootstrap'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { i18nTranslate } from 'src/utils'
import {
  addressContainer,
  accountsAddressContainer,
  storeContainer,
  customerContainer,
  checkoutContainer,
  nlxxConfigContainer,
} from 'src/models'
import { parsePhoneNumberField } from 'src/utils/signUpUtils'
import { application, isB2BUser, convertToBoolean } from 'src/utils'
import { AddressValidation, toastState } from 'src/views/components'
import { AddressList } from './AddressList'
import { APPConfig, IS_BROWSER } from 'config/appConfig'
import './styles.scss'
import { handleAddressValidation } from 'src/deps'
import SearchBar from 'src/views/components/Common/SearchBar'
import { normalizeForSearch } from 'src/utils/normalizeForSearch'
import {
  removeShippingAddressFormValidationMeta,
  shouldMakeLegacyAddressValidationApiCall,
  wasValidatedByShippingAddressForm,
} from 'src/views/components/CommonFormForCS/shippingAddressFormValidation'

@observer
class AddressBook extends React.Component {
  @observable isAddAddress = false
  @observable show = false
  @observable addressInvalidFlag = false
  @observable recommendations = []
  @observable addAddrsBtnDisable = false
  @observable formDataEnter = {}
  @observable search = ''

  searchInputRef = React.createRef()
  enableCheckoutAddressSearch =
    convertToBoolean(APPConfig?.getAppConfig()?.enableCheckoutAddressSearch) ||
    false

  ADDRESS_BOOK = 'ADDRESS_BOOK'
  ADDRESS_TITLE = 'ADDRESS_TITLE'
  ADDRESS_LIST = 'ADDRESS_LIST'

  currentMarket = storeContainer?.defaultShippingRegion
    ? 'Address' + storeContainer?.defaultShippingRegion
    : 'AddressUS'

  AddressForm = lazy(
    () =>
      import(
        'src/views/addresses/' + this.currentMarket + '/' + this.currentMarket
      )
  )

  constructor(props) {
    super(props)
    checkoutContainer.isInvalidPhoneCountryCodeIN = false
  }

  componentDidMount() {
    if (
      !nlxxConfigContainer.nlxxConfigStoreId ||
      nlxxConfigContainer.nlxxConfigStoreId !== storeContainer.activeStoreId
    ) {
      nlxxConfigContainer.loadNLXXConfig()
    }
    this.checkAndInit()
  }

  checkAndInit = () => {
    const customerResponse =
      customerContainer?.profileResponse?.customer ||
      customerContainer?.profileResponse
    if (customerResponse?.id) {
      addressContainer
        .getProfileAddress()
        .then(() => addressContainer.updateInitialDefaultAddress())
    } else {
      setTimeout(() => {
        this.checkAndInit()
      }, 300)
    }
  }

  toggleAddAddress = () => {
    this.isAddAddress = !this.isAddAddress
    if (!this.isAddAddress) {
      window.scrollTo(0, 0)
    }
  }

  handleAddAddress = async (formData = {}) => {
    if (this.addAddrsBtnDisable) return
    this.addAddrsBtnDisable = true
    const {
      phone = '',
      phoneCountryCode = '',
      isToMakeValidationApiCall = false,
      firstName,
      lastName,
      country = '',
      ...remainingProps
    } = formData

    const phoneObj =
      (await parsePhoneNumberField(phone, phoneCountryCode)) || {}
    const phoneNumber = phoneObj?.number || ''
    formData = {
      firstName: firstName?.trim(),
      lastName: lastName?.trim(),
      phone: phoneNumber,
      country,
      ...remainingProps,
    }

    let formDataTemp = {
      firstName: firstName?.trim(),
      lastName: lastName?.trim(),
      ...formData,
      shippingInstructions: formData.shippingInstructions,
      setDefaultAddress: formData?.setDefaultAddress || false,
    }

    const isToMakeAddressValidationApi =
      shouldMakeLegacyAddressValidationApiCall(
        { ...formData, isToMakeValidationApiCall },
        storeContainer?.defaultShippingRegion
      )

    if (isToMakeAddressValidationApi) {
      formData = removeShippingAddressFormValidationMeta(formData)
      formDataTemp = removeShippingAddressFormValidationMeta(formDataTemp)
      const res = (await addressContainer.validateAddress(formData)) || {}
      const recommendationAddress =
        res?.address?.validationDetails?.[0]?.recommendations || []
      if (res?.code === 'ADCOVAL0003') {
        this.recommendations = [{ ...formDataTemp }, []]
        this.addressInvalidFlag = true
        this.formDataEnter = { ...formDataTemp }
        this.show = true
      } else if (res?.code == 'ONESOURCE_ADPLGIN_VAL_ERROR') {
        this.setState({
          show: false,
        })
        toastState.setToastMessage(
          i18nTranslate('address.NotAdded', 'Address not added')
        )
        this.addAddrsBtnDisable = false
      } else if (res?.code == 'AOACHLD0001') {
        this.addAddrsBtnDisable = false
        this.setState({
          show: false,
        })
        toastState.setToastMessage(
          i18nTranslate(
            'myaccount.userHoldStatus',
            'There is an issue with your account. Please contact you local account manager.'
          )
        )
        return
      } else {
        this.recommendations = [{ ...formDataTemp }, ...recommendationAddress]
        this.addressInvalidFlag = false

        let firstAddress = recommendationAddress?.[0] || {}

        if (
          Object.keys(firstAddress)?.length > 0 &&
          handleAddressValidation(formDataTemp, firstAddress) &&
          res?.code !== 'ONESOURCE_ADPLGIN_VAL_ERROR'
        ) {
          this.formDataEnter = { ...formDataTemp }
          this.show = true
        } else if (res?.code !== 'ONESOURCE_ADPLGIN_VAL_ERROR') {
          await this.handleClickOnPro(formDataTemp, true)
        }
      }
    } else {
      await this.handleClickOnPro(formDataTemp, true)
    }
    this.addAddrsBtnDisable = false
  }

  handleClickOnPro = async (formData = {}, isCompleteMatch = false) => {
    const isValidatedByShippingAddressForm =
      wasValidatedByShippingAddressForm(formData)
    formData = removeShippingAddressFormValidationMeta(formData)

    let payload = {
      ...formData,
      setDefaultAddress:
        this.formDataEnter?.setDefaultAddress ||
        formData?.setDefaultAddress ||
        false,
    }
    this.formDataEnter = {}
    let response = {}
    if (/*isB2BAdmin() ||*/ isB2BUser()) {
      response = (await accountsAddressContainer.addAddress(payload)) || {}
    } else {
      if (formData.selectedIndex <= 0 && !isValidatedByShippingAddressForm) {
        response = await addressContainer.validateOriginalAddress(payload)
      } else {
        response = (await addressContainer.addAddress(payload)) || {}
      }
    }
    if (response.addressId) {
      this.handleClose()
    } else {
      this.addAddrsBtnDisable = false
      this.handleClose()
    }
    if (
      isB2BUser() ||
      formData.selectedIndex > 0 ||
      (formData.selectedIndex <= 0 &&
        addressContainer.isSuccessResponse(response)) ||
      isCompleteMatch
    ) {
      this.toggleAddAddress()
    }
  }

  handleClose = () => {
    this.show = false
  }

  getDataModal(dataKey, addressInfo = {}) {
    const shippingAddresses =
      (isB2BUser()
        ? accountsAddressContainer.addressData
        : addressContainer.addressData) || []
    const filteredAddresses = shippingAddresses?.filter(
      data => data?.type === 'shipping'
    )
    switch (dataKey) {
      case this.ADDRESS_LIST:
        return {
          addressId: addressInfo?.addressId || '',
        }
      case this.ADDRESS_BOOK:
        return {
          shippingAddresses: filteredAddresses,
          show: this.show || false,
          addressInvalidFlag: this.addressInvalidFlag || false,
          recommendations: this.recommendations || [],
          isAddAddress: this.isAddAddress || false,
          submitText: i18nTranslate('address.submit', 'Add Address'),
        }

      default:
        return {}
    }
  }

  getStyleGuides(dataKey) {
    switch (dataKey) {
      case this.ADDRESS_TITLE:
        return {
          addressBookText: i18nTranslate(
            'address.addressBookLabel',
            'Address Book'
          ),
          addNewAddressText: i18nTranslate(
            'address.addNewAddressButton',
            'Add New Address'
          ),
          message: i18nTranslate(
            'myprofile.submit.message',
            'Please switch to your home market to make any changes.'
          ),
          size: application.isMobile ? 'sm' : 'md',
          buttonStyle: {
            pointerEvents: this.isAddAddress ? 'none' : '',
          },
          buttonVariant: this.isAddAddress ? 'light' : 'primary',
        }

      default:
        return {}
    }
  }

  applyAddressFilter = (list = [], query = '') => {
    const text = normalizeForSearch(query).trim()
    if (!text) return list
    const terms = text.split(/\s+/).filter(Boolean)
    return list.filter(addr => {
      const haystack = [
        addr.firstName,
        addr.lastName,
        addr.addressLine1,
        addr.addressLine2,
        addr.city,
        addr.state,
        addr.stateName,
        addr.stateCode,
        addr.country,
        addr.countryName,
        addr.countryCode,
        normalizeForSearch(addr.zip),
      ]
        .map(normalizeForSearch)
        .filter(Boolean)
        .join(' ')
      return terms.every(t => haystack.includes(t))
    })
  }

  handleSearchChange = e => {
    this.search = e.target.value
  }

  handleClearSearch = () => {
    this.search = ''
    this.searchInputRef?.current?.focus?.()
  }

  renderAddressList = (addressInfo = {}, index) => {
    const data = this.getDataModal(this.ADDRESS_LIST, addressInfo)
    return (
      <AddressList
        addressInfo={addressInfo}
        index={index}
        key={`addressInfo${data?.addressId}`}
      />
    )
  }

  renderAddressTitle = () => {
    const styles = this.getStyleGuides(this.ADDRESS_TITLE)
    const isCrossMarketAllowedFlag =
      customerContainer.isCrossMarketAllowed() || false

    return (
      <>
        <div className={`${isCrossMarketAllowedFlag ? '' : 'd-none'}`}>
          <Col className="d-flex flex-row align-items-center justify-content-between p-0">
            <div>
              <h1
                data-testid="qa-addresses-heading"
                className="account-addressbook-title mb-0 pr-3 heading-2">
                {styles?.addressBookText}
              </h1>
            </div>
            {!isB2BUser() && (
              <Button
                className="account-addressbook-addnew-button d-inline px-3"
                onClick={this.toggleAddAddress}
                variant={styles?.buttonVariant}
                size={styles?.size}
                style={styles?.buttonStyle}
                data-testid="qa-add-address-button">
                {styles?.addNewAddressText}
              </Button>
            )}
          </Col>
        </div>
        {!isCrossMarketAllowedFlag && (
          <div className="non-home-market-country">{styles?.message}</div>
        )}
      </>
    )
  }

  renderAddressBookSubmitButton = () => {
    return (
      <Row noGutters className="justify-content-normal address-button">
        <div className="d-flex">
          <div>
            <Button
              variant="primary"
              disabled={this.addAddrsBtnDisable || false}
              className="add-button-addressBook mt-2 shipping-button-addressBook justify-content-center align-items-center"
              type="submit"
              data-testid="qa-submit-changes">
              {i18nTranslate('address.submit', 'Add Address')}
            </Button>
          </div>
          <div className="ml-3">
            <Button
              variant="outline-primary"
              className="cancel-button-addressBook mt-2 shipping-button-addressBook justify-content-center align-items-center"
              onClick={this.toggleAddAddress}
              data-testid="qa-address-cancel">
              {i18nTranslate('address.cancel', 'Cancel')}
            </Button>
          </div>
        </div>
      </Row>
    )
  }

  render() {
    const data = this.getDataModal(this.ADDRESS_BOOK)
    const source = data?.shippingAddresses || []
    const filtered = this.applyAddressFilter(source, this.search)
    const hasQuery = Boolean((this.search || '').trim())
    const isNoResults = hasQuery && filtered.length === 0

    return (
      <Container className="p-0" data-testid="qa-address-list-container">
        {data?.show && (
          <AddressValidation
            open={data?.show}
            addressInvalidFlag={data?.addressInvalidFlag}
            recommendations={data?.recommendations}
            handleClickOnPro={this.handleClickOnPro}
            handleClose={this.handleClose}
          />
        )}

        <Row noGutters className="p-3 mb-3 flex-column bg-white shadow-sm">
          {this.renderAddressTitle()}
          {data?.isAddAddress && IS_BROWSER && (
            <Col className="pt-4 p-0">
              <Suspense fallback="">
                <this.AddressForm
                  newAddress={true}
                  onSubmit={this.handleAddAddress}
                  onCancel={this.toggleAddAddress}
                  addAddress={true}
                  renderSubmitButton={this.renderAddressBookSubmitButton}
                  shippingAddresses={data?.shippingAddresses}
                  type="addressBook"
                  className="py-3"
                />
              </Suspense>
            </Col>
          )}
        </Row>

        {this.enableCheckoutAddressSearch && (
          <Row noGutters className="mb-3">
            <Col className="p-0">
              <SearchBar
                ref={this.searchInputRef}
                value={this.search}
                onChange={this.handleSearchChange}
                onClear={this.handleClearSearch}
                placeholder={i18nTranslate(
                  'address.search.placeholder',
                  'Search Address'
                )}
              />
            </Col>
          </Row>
        )}

        {isNoResults ? (
          <div
            className="address-no-results text-muted py-2"
            role="status"
            aria-live="polite"
            data-testid="qa-address-no-results">
            {i18nTranslate('viewCart.searchNoResults', 'No Results Found')}
          </div>
        ) : (
          (this.enableCheckoutAddressSearch ? filtered : source)?.map(
            this.renderAddressList
          )
        )}
      </Container>
    )
  }
}

export { AddressBook }
export default AddressBook
